<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

@Component({
  name: 'legacy-bootstrap-datepicker',
  mixins: [DatePicker],
})
export default class LegacyBootstrapDatepicker extends Vue {
}
</script>

<style scoped lang="less">

</style>
